import Gigya from './gigya.js'
import FidmOidcOp from './fidm.oidc.op.js'
import FidmOidcRp from './fidm.oidc.rp.js'

export * from './interfaces/gigya-response.js'
export * from './fidm.oidc.op.js'
export * from './fidm.oidc.rp.js'

export class FidmOidc {
	public readonly op: FidmOidcOp
	public readonly rp: FidmOidcRp

	constructor(protected gigya: Gigya) {
		this.op = new FidmOidcOp(gigya)
		this.rp = new FidmOidcRp(gigya)
	}
}

export default FidmOidc
